export default (targetValue, array = []) =>
    array.reduce((count, value) => (value === targetValue ? count + 1 : count), 0);
